import { Tooltip } from 'antd';
import { TooltipPropsWithTitle } from 'antd/lib/tooltip';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

// https://ant.design/components/tooltip/#API
interface ITooltip extends TooltipPropsWithTitle {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    title: string | any;
}

const TooltipComponent: React.FC<ITooltip> = props => {
    const { title, ...rest } = props;
    return (
        <Tooltip {...rest} title={typeof title === 'string' ? <TranslateText>{title}</TranslateText> : title}>
            {props.children}
        </Tooltip>
    );
};

export default TooltipComponent;
